import React, { Fragment, useState, useEffect } from 'react'

import CampaignPage from 'Containers/Campaigns/Page'
import { CityPlansFiltersWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansFiltersWrapper'
import { CityPlansWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansWrapper'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { apiClient as API } from 'Module/API/Client'
import getBonusResultsData from './gql'

const formatCurrency = (amount, currency) => `${currency}${amount}`
const sortTableColumns = (items, selectedCity, columnName, isReverse) => {
  const sortedItems = items
    .filter(({ cityId }) => cityId == selectedCity)
    .sort((a, b) =>
      a[columnName] > b[columnName]
        ? 1
        : b[columnName] > a[columnName]
        ? -1
        : 0,
    )

  if (isReverse) {
    return sortedItems.reverse()
  } else {
    return sortedItems
  }
}
const BonusResults = props => {
  const {
    match: {
      params: { campaignId },
    },
  } = props

  const [state, setState] = useState({
    cities: [],
    citiesOptions: [],
    selectedCity: null,
    bonusResults: {},
    loading: true,
    columnName: 'name',
    isReverse: false,
  })

  useEffect(() => {
    getInitialData()
  }, [])

  const getInitialData = async () => {
    const { campaignId } = props.match.params
    const { data } = await getBonusResultsData(campaignId)
    const cityPlans = data.campaign.cityPlans.nodes
    const cities = cityPlans.map(({ city }) => city)
    const citiesOptions = cities.map(city => ({
      label: city.name,
      value: city.id,
    }))
    const bonusResponse = await API.getBonusResults(campaignId)
    const bonusResults = await bonusResponse.json()

    setState(state => ({
      ...state,
      cities,
      citiesOptions,
      bonusResults,
      selectedCity: citiesOptions[0] ? citiesOptions[0].value : null,
      loading: false,
    }))
  }

  /**
   * Render city filter select
   *
   * @returns {*}
   */
  const renderCitySelectFilter = () => {
    const { citiesOptions } = state
    return (
      <FilterSelect
        label="City"
        onChange={(element, index, value) => {
          setState(state => ({ ...state, selectedCity: value }))
        }}
        options={citiesOptions}
        value={state.selectedCity}
        sorted={true}
      />
    )
  }

  const renderTable = () => {
    /* TODO: KPI#1, KPI#2 - TBD */

    const bonusResults = state.bonusResults.baResults
    const {
      bonusAllowance,
      bonusPerConversion,
      bonusPaidSoFar,
      bonusUsage,
      currency,
    } = state.bonusResults
    const bonusRemainder = parseFloat(bonusAllowance - bonusPaidSoFar).toFixed(
      2,
    )

    const rows = sortTableColumns(
      bonusResults,
      state.selectedCity,
      state.columnName,
      state.isReverse,
    ).map(renderRow)
    const changeSort = event => {
      const columnName = event.target.id
      if (state.columnName == columnName) {
        setState(state => ({ ...state, isReverse: !state.isReverse }))
      } else {
        setState(state => ({
          ...state,
          columnName: columnName,
          isReverse: !state.isReverse,
        }))
      }
    }
    return (
      <Fragment>
        {!bonusResults || bonusResults.length == 0 ? (
          <div style={{ marginTop: 10 }}>
            <span>There are no bonus results for this campaign.</span>
          </div>
        ) : null}
        <div>
          <div
            style={{
              display: 'flex',
              marginTop: 60,
              justifyContent: 'space-around',
            }}
          >
            <div className="kpi">
              <span>{`Bonus Allowance: ${formatCurrency(
                bonusAllowance,
                currency,
              )}`}</span>
            </div>

            <div className="kpi">
              <span>{`Bonus/conv: ${formatCurrency(
                parseFloat(bonusPerConversion).toFixed(2),
                currency,
              )}`}</span>
            </div>
            <div className="kpi">
              <span>{`Bonus Remainder: ${formatCurrency(
                bonusRemainder,
                currency,
              )}`}</span>
            </div>
            <div className="kpi">
              <span>{`Bonus usage: ${bonusUsage}%`}</span>
            </div>
          </div>
          <Table>
            <thead>
              <Tr>
                <Th className="sortable" id={'name'} onClick={changeSort}>
                  Name
                </Th>
                <Th
                  className="sortable"
                  id={'missionsCount'}
                  onClick={changeSort}
                >
                  # Missions
                </Th>
                <Th
                  className="sortable"
                  id={'conversionsCount'}
                  onClick={changeSort}
                >
                  # Conversions
                </Th>
                <Th
                  className="sortable"
                  id={'totalBonusPaid'}
                  onClick={changeSort}
                >
                  $ Total bonus paid
                </Th>
              </Tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        </div>
      </Fragment>
    )
  }
  const renderRow = row => {
    return (
      <Tr key={`bonus-${row.name}`}>
        <Td>{row.name}</Td>
        <Td>{row.missionsCount}</Td>
        <Td>
          {row.conversionsCount === null ? 'Not updated' : row.conversionsCount}
        </Td>
        <Td>{parseFloat(row.totalBonusPaid).toFixed(2)}</Td>
      </Tr>
    )
  }

  return (
    <CampaignPage
      active={props.nav}
      campaignId={campaignId}
      match={props.match}
      history={props.history}
    >
      <CityPlansWrapper>
        <LayoutDashboard>
          <CityPlansFiltersWrapper>
            {!state.loading ? renderCitySelectFilter() : null}
          </CityPlansFiltersWrapper>
        </LayoutDashboard>
        {!state.loading ? renderTable() : null}
      </CityPlansWrapper>
    </CampaignPage>
  )
}

export default BonusResults



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/BonusResults/index.js